import type {BigCalendarEvent} from '../types/BigCalendarEvent';
import {isMultiDayEvent} from './isMultiDayEvent';

/**
 * Whether the week and day views draw the event in the all-day header instead of the timeline.
 * All-day events belong there by definition; multi-day events belong there because a bar across
 * day columns reads better than a full-height block repeated in every column.
 */
export const isAllDayHeaderEvent = (event: BigCalendarEvent) =>
  event.isAllDay === true || isMultiDayEvent(event.start, event.end);
